import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { WorkflowItemDataDirective } from './workflow-item-data/workflow-item-data.directive';
import { WorkflowItemKeyDirective } from './workflow-item-key/workflow-item-key.directive';
import { WorkflowItemDirective } from './workflow-item/workflow-item.directive';
import { EndWorkflowItemDirective } from '@workflow/directives/end-workflow-item/end-workflow-item.directive';
import { WorkflowItemStatusDirective } from './workflow-item-status/workflow-item-status.directive';

@NgModule({
	declarations: [
		EndWorkflowItemDirective,
		WorkflowItemDirective,
		WorkflowItemKeyDirective,
		WorkflowItemDataDirective,
		WorkflowItemStatusDirective,
	],
	exports: [
		EndWorkflowItemDirective,
		WorkflowItemDirective,
		WorkflowItemKeyDirective,
		WorkflowItemDataDirective,
		WorkflowItemStatusDirective,
	],
	imports: [
		CommonModule
	]
})
export class WorkflowDirectivesModule { }
